import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { InputLabel, TextField } from "@material-ui/core";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core";
import Select from "../../components/formUI/Select";
import NavBar from "../../components/navbar/NavBar";
import styles from "./Settlement.module.scss";
import {
	openLoader,
	closeLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
			{
				textAlign: "center",
				padding: "8.1px 14px",
			},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

const ProcessorSettlement = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const [startDate, setStartDate] = useState<any>(new Date());
	const [endDate, setEndDate] = useState<any>(new Date());

	const [providers, SetProviders] = useState<any>();

	// const [input, setInput] = useState({
	// 	currentPassword: "",
	// 	newPassword: "",
	// });

	const fetchProviders = async () => {
		dispatch(openLoader());
		try {
			const data: any = await axios.get(`/v1/utility/providers`);
			SetProviders(data?.data);
			dispatch(closeLoader());
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent:
							err.response?.data?.message ||
							err?.data?.message ||
							err?.message ||
							err,
						toastType: "error",
					})
				)
			);
		}
	};

	let providerOptions = providers?.providers?.map(function (bank: any) {
		return {
			value: bank.id,
			name: bank.providershortname,
		};
	});

	useEffect(() => {
		fetchProviders();
	}, []);

	const INITIAL_VALUES = {
		provider: "",
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				background: "#EFF3F8",
				height: "100%",
				overflowY: "scroll",
			}}
		>
			<NavBar name="Settlements" />
			<div className={styles.fileBackground}>
				<span className={styles.fileText}>
					Download Provider Settlement Files
				</span>
				<div className={styles.updatePassword}>
					<Formik
						initialValues={INITIAL_VALUES}
						// validationSchema={validate}
						onSubmit={(values) => {
							dispatch(openLoader());

							const payload = {
								processor: values.provider,
								fromdate: startDate.toISOString().split("T")[0],
								todate: endDate.toISOString().split("T")[0],
							};

							axios
								.post(`/v1/settlement/processor/file/download`, payload)
								.then((res: any) => {
									const filename = `${payload.processor}_${payload.fromdate}_${payload.todate}.csv`;
									const url = window.URL.createObjectURL(new Blob([res.data]));
									const link = document.createElement("a");
									link.href = url;
									link.setAttribute("download", filename);
									document.body.appendChild(link);
									link.click();
									link.remove();
									dispatch(closeLoader());
									// dispatch(
									//   openToastAndSetContent({
									//     toastContent: res.data.message
									//   })
									// );
								})
								.catch((err) => {
									dispatch(closeLoader());
									dispatch(
										openToastAndSetContent({
											toastContent: err.response.data.message,
											toastType: "error",
										})
									);
								});
						}}
					>
						{(props) => (
							<Form>
								<div className={styles.passwordSection}>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											width: "316px",
										}}
									>
										<InputLabel>
											<span className={styles.label}>Select a provider</span>
										</InputLabel>
										<Field
											as={Select}
											helperText={
												<ErrorMessage name="provider">
													{(msg) => <span style={{ color: "red" }}>{msg}</span>}
												</ErrorMessage>
											}
											name="provider"
											size="small"
											options={providerOptions}
											defaultValue={providerOptions && providerOptions[0]}
											className={classes.select}
											// fullWidth
											style={{
												marginTop: "5px",
											}}
										/>
									</div>

									<div style={{ marginLeft: "40px", width: "416px" }}>
										<div
											className={styles.label}
											style={{ marginBottom: "4px" }}
										>
											Select date range
										</div>
										<span style={{ display: "flex", gap: "10px" }}>
											<DatePicker
												selected={startDate}
												required={true}
												onChange={(fromdate: Date) => setStartDate(fromdate)}
												maxDate={new Date()}
												placeholderText="Select start date"
												wrapperClassName={styles.datePicker}
												dateFormat="dd/MM/yyyy"
											/>
											<span>__</span>
											<DatePicker
												selected={endDate}
												required={true}
												onChange={(todate: Date) => setEndDate(todate)}
												maxDate={new Date()}
												placeholderText="Select end date"
												wrapperClassName={styles.datePicker}
												dateFormat="dd/MM/yyyy"
											/>
										</span>
									</div>
								</div>

								<button
									style={{
										backgroundColor: "#27AE60",
										fontFamily: "Avenir",
										fontStyle: "normal",
										fontWeight: "normal",
										fontSize: "14px",
										lineHeight: "19px",
										textAlign: "center",
										border: "none",
										outline: "none",
										color: "#FFFFFF",
										marginTop: "30px",
										cursor: "pointer",
										borderRadius: "20px",
										width: "154px",
										padding: "7px 16px",
									}}
									type="submit"
								>
									Download CSV File
								</button>
							</Form>
						)}
					</Formik>
				</div>
			</div>
		</div>
	);
};

export default ProcessorSettlement;
